import React from 'react';
import { IconStyled, IconStylesProps } from './IconStyles';

export const Info = ({ size = 'base', className = '' }: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L24 0 24 24 0 24z" />
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
      />
    </g>
  </IconStyled>
);
